import React, { useMemo, useCallback } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import moment from 'moment';
import { DateRange } from 'react-date-range';
import { enUS, it, pt, de } from 'date-fns/locale';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const StyledDateRange = styled(DateRange)`
  width: 100%;

  .rdrDateDisplayWrapper {
    background-color: transparent;
  }

  .rdrDateDisplay {
    margin: 0;
  }

  .rdrDateInput {
    height: 44px;
  }

  .rdrDateDisplayItem {
    box-shadow: none;
    border: 2px solid ${themeGet('colors.primary_200')};

    & > input {
      font-size: 16px;
      height: 100%;
    }
  }

  .rdrDateDisplayItemActive {
    box-shadow: none;
    border: 2px solid ${themeGet('colors.primary_300')};
  }

  .rdrDayToday .rdrDayNumber span:after {
    background: ${themeGet('colors.primary_300')};
  }

  .rdrMonthAndYearPickers select:hover {
    background-color: transparent;
  }
`;

function CustomDateRange({ maxRange, minDate, languageCode, onChange, value }) {
  const dates = useMemo(
    () => ({
      startDate: moment(value[0]).toDate(),
      endDate: moment(value[1]).toDate(),
      key: 'selection',
    }),
    [value],
  );

  const handleChange = useCallback(
    (item) => {
      const {
        selection: { startDate, endDate },
      } = item;

      let endDateFormatted = moment(endDate);

      if (maxRange && moment(startDate).add(maxRange, 'months').isBefore(endDateFormatted)) {
        endDateFormatted = moment(startDate);
      }

      if (moment(endDate).isAfter(moment())) {
        endDateFormatted = moment();
      }

      onChange([moment(startDate), endDateFormatted]);
    },
    [onChange, maxRange],
  );

  const maxDate = useMemo(() => {
    if (maxRange) {
      return moment(value[0]).add(maxRange, 'months').toDate();
    } 
      return moment().toDate();
    
  }, [maxRange, value]);

  return (
    <StyledDateRange
      editableDateInputs
      months={2}
      direction="horizontal"
      onChange={handleChange}
      moveRangeOnFirstSelection={false}
      minDate={minDate}
      maxDate={maxDate}
      ranges={[dates]}
      rangeColors={['#0A8EA0']}
      dateDisplayFormat="dd MMM yyyy"
      locale={
        languageCode === 'it' ? it : languageCode === 'de' ? de : languageCode === 'pt' ? pt : enUS
      }
    />
  );
}

export default CustomDateRange;
